<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="2">
          <v-subheader>نوع ارسال</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-select :items="items" v-model="selectItem" label="نوع ارسال"  reverse></v-select>
        </v-col>
      </v-row> -->
      <v-row justify="center mb-3">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/product-management/shippingType">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
  created() {
    axios
      .get(`${baseURL}shippingType/GetById?id=${this.$route.params.id}`)
      .then((res) => {
        this.title = res.data.data.title;
      });
      // axios.get(`${baseURL}ShippingType/GetAll`)
      //   .then((res)=>{
      //     res.data.data.map((item)=>{
      //       this.items.push({
      //         text:item.title,
      //         value:item.id,
      //       })
      //     })
      //   })
  },

  data() {
    return {
      id: this.$route.params.id,
      title: "",
      description: "",
      shippingTypeId: "",
      type: 0,
      shippingDose: "",
      list: [],
      items: [],
      selectItem: "null",
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    onFileSelected(event) {
      this.image = event.target.files[0];
    },
    async editHandler() {
      this.list.map((item) => {
        if (item.title == this.selectItem) {
          this.selectItem = item.id;
        }
      });
      await axios
        .put(
          `${baseURL}shippingType/Edit`,
          {
            id: this.id,
            title:this.title,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/product-management/shippingType");
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>